import script from "./SuccessPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessPage.vue?vue&type=script&setup=true&lang=js"

import "./SuccessPage.vue?vue&type=style&index=0&id=014b07f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-014b07f3"]])

export default __exports__